import { transformImageUrl } from '../../services/CloudinaryService'
import { calculatePhotoThumbDimensions } from '../PhotoBank/PhotoBank.utils'

export const extractThumbDimensionsFromUrl = (url: string) => {
  if (url === undefined) {
    return {}
  }
  const regex = /c_thumb,w_\d+,h_\d+/g
  const match = url.match(regex)
  if (!match) {
    return {}
  }

  const parts = match[0].split(',')
  const width = parseInt(parts[1].split('w_')[1])
  const height = parseInt(parts[2].split('h_')[1])
  return {
    width,
    height,
  }
}

export const getVaryingResolutionImageUrls = ({
  url,
  width,
  height,
}: {
  url: string
  width: number
  height: number
}) => {
  const thumbDimensions = calculatePhotoThumbDimensions(width, height)
  const minimalResUrl = transformImageUrl(
    url,
    undefined,
    thumbDimensions.minimal,
    true
  )
  const highResUrl = transformImageUrl(
    url,
    undefined,
    thumbDimensions.high,
    true
  )

  return {
    minimalResUrl,
    // lowResUrl aliases minimalResUrl: Cloudinary bills per derived asset, so no
    // 700px variant may be requested.
    lowResUrl: minimalResUrl,
    highResUrl,
  }
}
